// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1f458173","576":"eb91844e"}[chunkId] + ".chunk.js";
};